var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 47,
    viewBox: "0 0 54 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10429 0.143156C3.72213 0.312939 3.37549 0.678896 3.22805 1.06823C3.15106 1.27137 3.11718 6.89986 3.11718 19.4856V37.6105H7.79296H12.4687V19.3384V1.06626L12.2349 0.72368C11.7466 0.00818211 11.6722 -0.00407891 7.84657 0.000492962C5.22004 0.00361015 4.34296 0.037068 4.10429 0.143156ZM29.3535 6.30282C28.9911 6.3954 28.4534 6.86921 28.3034 7.22831C28.1818 7.51925 28.1586 9.98671 28.1586 22.5927V37.6105H32.8343H37.5101V22.5164C37.5101 7.99098 37.5028 7.4089 37.3165 7.0604C36.9089 6.29804 36.8365 6.28474 32.9902 6.26624C31.1043 6.2572 29.4678 6.27362 29.3535 6.30282ZM16.4691 12.7625C15.6679 13.2574 15.7451 11.9528 15.7146 25.5163L15.6872 37.6105H20.3644H25.0414V25.6856C25.0414 12.3492 25.0972 13.3374 24.3141 12.8029C23.8258 12.4695 17.0002 12.4344 16.4691 12.7625ZM41.5645 18.9855C41.3657 19.0854 41.0967 19.326 40.9671 19.5202L40.7312 19.8733V28.7419V37.6105H45.407H50.0828V28.8467V20.0831L49.8464 19.6361C49.409 18.809 49.3795 18.8035 45.4086 18.8037C42.3005 18.8038 41.8873 18.8233 41.5645 18.9855ZM0 43.2332C0 46.1211 0.058707 46.3551 0.883202 46.7542C1.56025 47.0819 51.6397 47.0819 52.3167 46.7542C53.1412 46.3551 53.1999 46.1211 53.1999 43.2332V40.7277H26.6H0V43.2332Z",
    fill: "#7DA4B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.6c49c9fd1516bd096c880aee4dffd3ed.svg";
export { ForwardRef as ReactComponent };